import { ReactElement, useMemo } from "react"
// eslint-disable-next-line import/no-extraneous-dependencies
import EChartsReact from "echarts-for-react"

type Props = {
  data: {
    isOutlier: number
    normal: number
  }
}

const outliersConfig = {
  normal: { label: "Validated Prices", color: "#10B981" },
  isOutlier: { label: "Price Outliers", color: "#FEF08A" },
} as const

const OutliersChart = ({ data }: Props): ReactElement => {
  const chartData = useMemo(() => {
    return Object.entries(outliersConfig)
      .map(([key, config]) => ({
        name: config.label,
        value: data[key as keyof typeof outliersConfig],
        itemStyle: { color: config.color },
      }))
      .filter(item => item.value > 0)
  }, [data])

  const option = {
    legend: { show: true, bottom: 0, itemGap: 8 },
    tooltip: {
      trigger: "item",
      formatter: "{b}: <b>{c}</b> ({d}%)",
    },
    series: [
      {
        name: "Observations",
        type: "pie",
        radius: ["30%", "60%"],
        avoidLabelOverlap: false,
        label: {
          formatter: "{d}%",
          position: "inside",
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 13,
            fontWeight: "bold",
          },
        },
        labelLine: {
          show: false,
        },
        data: chartData,
      },
    ],
  }

  return <EChartsReact option={option} style={{ height: 350, width: 350 }} notMerge lazyUpdate className="m-auto" />
}

export default OutliersChart
